export const FETCHING = "FETCHING";
export const ERROR = "ERROR";
export const IDLE = "IDLE";
